import React from "react";
import { Link } from "react-router-dom";

const PrintingServiceSection: React.FC = () => {
  return (
    <>
      <style>{`
      @media (max-width: 767px) {
        .printing-service-subtitle {
          padding-right: 20px;
          text-align: left;
        }
      }
    `}</style>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-a55bf6b scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
        data-id="a55bf6b"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div className="elementor-background-overlay"></div>

        <div className="elementor-container elementor-column-gap-extended">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-cb18556"
            data-id="cb18556"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">

              <div
                className="elementor-element elementor-element-765226d sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer"
                data-id="765226d"
                data-element_type="widget"
                data-widget_type="spacer.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>

              <div
                data-animation-type="block"
                className="elementor-element elementor-element-a588e43 animation_type_block sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                data-id="a588e43"
                data-element_type="widget"
                data-settings='{"_animation":"fadeIn"}'
                data-widget_type="trx_sc_title.default"
              >
                <div className="elementor-widget-container">
                  <div className="sc_title sc_title_default">

                    {/* Centered Subtitle */}
                    <span className="sc_item_subtitle sc_title_subtitle sc_align_center sc_item_subtitle_above sc_item_title_style_default" style={{ marginBottom: '40px', display: 'block', color: '#ffffff' }}>
                      Let’s Build Something Together
                    </span>

                    {/* Split Content Row */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      textAlign: 'left'
                    }}>
                      {/* Left Column: Titles */}
                      <div style={{ flex: '1 1 60%', minWidth: '300px' }}>
                        <h1 className="sc_item_title sc_title_title sc_align_left sc_item_title_style_default sc_item_title_tag" style={{ margin: '0 0 20px 0' }}>
                          <span className="sc_item_title_text">
                            Have an idea you’d like to bring to life?
                          </span>
                        </h1>
                        <h4 className="sc_item_title sc_title_title sc_align_left sc_item_title_style_default sc_item_title_tag printing-service-subtitle" style={{ margin: '0', lineHeight: '25px' }}>
                          <span className="sc_item_title_text" style={{ fontWeight: '400', fontSize: '18px', color: '#ffffff', paddingRight: '5px' }}>
                            Explore our services or get in touch to start your <br />
                            3D printing project with Modli 3D
                          </span>
                        </h4>
                      </div>

                      {/* Right Column: Button */}
                      <div className="sc_item_button sc_button_wrap sc_align_right sc_item_button sc_item_button_default sc_item_button_size_normal sc_title_button" style={{ marginTop: '20px' }}>
                        <Link
                          to="/contact"
                          className="sc_button sc_button_default sc_button_size_normal sc_button_icon_left"
                        >
                          <span className="sc_button_text">
                            <span className="sc_button_title">Contact us</span>
                          </span>
                        </Link>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div
                className="elementor-element elementor-element-47592cc sc_height_huge sc_layouts_hide_on_tablet sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                data-id="47592cc"
                data-element_type="widget"
                data-widget_type="spacer.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>

              <div
                className="elementor-element elementor-element-c51dd0b sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer"
                data-id="c51dd0b"
                data-element_type="widget"
                data-widget_type="spacer.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
                    <div className="elementor-spacer-inner"></div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrintingServiceSection;
